import React from "react";
import styled from "styled-components";

export const StyledFooter = styled.div`
  flex-shrink: 0;
  background-color: white;
  color: grey;
  text-align: center;
  padding: 1rem 0;
  p {
    font-weight: 300;
    font-size: 0.9rem;
  }
`;
function Footer() {
  return (
    <StyledFooter>
      <p>© AND Kraken. All Rights Reserved</p>
    </StyledFooter>
  );
}

export default Footer;
